let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iP4rw")).then(() => parcelRequire('c5Zzp'));